export default __webpack_public_path__ + "static/media/11e767f010dafa2bb2dbf32de407a3f4.svg";